// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"d6a4233b","140":"2b6ec5e7","325":"da484562","561":"fa2deeef","773":"2795381f"}[chunkId] + ".css";
};